// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  // baseUrl: 'http://192.168.1.100:2060',
  // domainUrl: '192.168.1.100:2060',
  baseUrl: 'https://localhost:44311',
  domainUrl: 'localhost:44311/',
  // baseUrl: 'https://api-learnyacademy.test.aldawal.com',
  // domainUrl: 'api-learnyacademy.test.aldawal.com',
  payUrl: 'https://pay.aldawal.com',
  // reportUrl:'https://api.fatora.aldawal.com',
  // systemUrl: 'https://admin.4signing.com'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
